import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Logout: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.96094 8.23035C5.83581 8.23035 5.73438 8.12897 5.73438 8.00378C5.73438 7.87866 5.83581 7.77722 5.96094 7.77722"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5.96094 8.23035C6.08607 8.23035 6.1875 8.12897 6.1875 8.00378C6.1875 7.87866 6.08607 7.77722 5.96094 7.77722"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M10.2656 2.5625H12.9844C13.2247 2.5625 13.4553 2.65798 13.6252 2.82793C13.7952 2.99789 13.8906 3.2284 13.8906 3.46875V12.5312C13.8906 12.7716 13.7952 13.0021 13.6252 13.1721C13.4553 13.342 13.2247 13.4375 12.9844 13.4375H10.2656"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.93354 14.7909L2.49607 14.0417C2.38775 14.0256 2.2889 13.9709 2.21782 13.8876C2.14673 13.8042 2.10822 13.698 2.1094 13.5886V2.9975C2.11114 2.89544 2.14728 2.79696 2.21198 2.718C2.27668 2.63905 2.36614 2.58426 2.46586 2.5625L7.90334 1.22125C7.96937 1.20683 8.03776 1.20736 8.10356 1.2228C8.16935 1.23825 8.23085 1.2682 8.2836 1.31049C8.33628 1.35277 8.37887 1.40631 8.40824 1.46718C8.43754 1.52805 8.45289 1.59472 8.45313 1.66229V14.3498C8.45313 14.4146 8.43899 14.4787 8.4118 14.5375C8.38455 14.5964 8.3448 14.6486 8.29538 14.6905C8.24596 14.7325 8.18802 14.7632 8.12555 14.7805C8.06302 14.7978 7.99752 14.8014 7.93354 14.7909Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
